import { useMemo } from "react";
import {
  buildActiveFilters,
  buildBoardColumns,
  buildComboData,
  buildFilteredDefects,
  buildMyDefects,
  buildRangeStats,
  countActiveFilters,
} from "../services/defectsViewDerivations";

export function useDefectsViewDerived({
  defects,
  range,
  customRange,
  lcSelected,
  search,
  appliedFilters,
  filterMode,
  viewTab,
  user,
}) {
  const rangeDefects = useMemo(() => (Array.isArray(defects) ? defects : []), [defects]);

  const comboData = useMemo(
    () => buildComboData({ defects: rangeDefects, range, customRange }),
    [rangeDefects, range, customRange]
  );

  const rangeStats = useMemo(() => buildRangeStats(rangeDefects), [rangeDefects]);

  const filteredDefects = useMemo(
    () => buildFilteredDefects({ defects: rangeDefects, lcSelected, search, appliedFilters, filterMode }),
    [rangeDefects, lcSelected, search, appliedFilters, filterMode]
  );

  const myDefects = useMemo(
    () => buildMyDefects(filteredDefects, user, viewTab),
    [filteredDefects, user, viewTab]
  );

  const tableDefects = viewTab === "mine" ? myDefects : filteredDefects;

  const boardColumns = useMemo(() => buildBoardColumns(tableDefects), [tableDefects]);

  const activeFilters = useMemo(
    () => buildActiveFilters({ lcSelected, search, appliedFilters }),
    [lcSelected, search, appliedFilters]
  );

  const activeFilterCount = useMemo(
    () => countActiveFilters(appliedFilters),
    [appliedFilters]
  );

  return {
    rangeDefects,
    comboData,
    rangeStats,
    filteredDefects,
    myDefects,
    tableDefects,
    boardColumns,
    activeFilters,
    activeFilterCount,
  };
}
